import moment from "moment"

// Icons
import { Workflow, ChevronRight, Plus } from "lucide-react"

// UI components
import Button from "../../../components/ui/button/button"

// ---------------------------------------------------------------------------
// The saved flows list - shown in the left panel when no flow is open.
// Hovering a flow previews its diagram on the canvas; clicking opens it in
// the builder.
// ---------------------------------------------------------------------------
export default function FlowList({ flows, loading, creating, onOpen, onCreate, onPreview }) {
	// Shimmering skeleton rows while the first snapshot loads
	if (loading) {
		return (
			<div className="qa-flow-list">
				{[0, 1, 2].map((index) => (
					<div key={index} className="qa-flow-skeleton" style={{ animationDelay: `${index * 120}ms` }} />
				))}
			</div>
		)
	}

	// Nothing saved yet - a friendly nudge to build the first flow
	if (!flows.length) {
		return (
			<div className="qa-panel-empty">
				<div className="qa-panel-empty-icon">
					<Workflow size={22} />
				</div>
				<h3>No flows yet</h3>
				<p>Map out which hotels to quote alongside the one a client enquires for. Start with the enquiry hotel, then add the alternatives.</p>
				<Button
					small={true}
					label="New flow"
					icon={<Plus size={15} />}
					loading={creating}
					loadingText="Creating..."
					onClick={onCreate}
				/>
			</div>
		)
	}

	return (
		<div className="qa-flow-list">
			<p className="qa-panel-hint">Pick a flow to edit it, or hover one to preview the diagram.</p>

			{flows.map((flow, index) => (
				<div
					key={flow.id}
					className="qa-flow-card"
					style={{ animationDelay: `${index * 45}ms` }}
					onClick={() => onOpen(flow.id)}
					onMouseEnter={() => onPreview(flow.id)}
					onMouseLeave={() => onPreview(null)}>
					<div className="qa-flow-card-icon">
						<Workflow size={16} />
					</div>

					<div className="qa-flow-card-copy">
						<p>{flow.start?.title || "Untitled flow"}</p>
						<small>
							{(flow.alternatives || []).length === 1 ? "1 alternative" : `${(flow.alternatives || []).length} alternatives`}
							{flow.created?.seconds ? ` - created ${moment.unix(flow.created.seconds).format("MMM D, YYYY")}` : ""}
						</small>
					</div>

					<ChevronRight size={15} className="qa-flow-card-chevron" />
				</div>
			))}
		</div>
	)
}
